<template>
  <div class="container mx-auto">
    <div class="flex flex-wrap">
      <div class="px-4 w-full">
        <BigTitle title="Settings" class="mb-11 pt-40"/>
        <Team />
      </div>
    </div>
  </div>
</template>

<script>
  import Team from '@/components/settings/Team'
  import BigTitle from '@/components/BigTitle'

  export default {
    components: {
      Team,
      BigTitle
    },
  }
</script>

<style lang="scss" scoped>

</style>